import { useTranslation } from 'next-i18next';
import { useEffect, useState, Fragment } from 'react';
import styles from '@features/showrooms/sections/ShowroomSection/Components/FourProjects/FourProjects.styles';
import Heading from '@components/Heading/Heading';
import getArticles from '@utils/pages/getArticles';
import { ICmsArticles } from '@features/cms/typescript';
import SingleArticleInspirations from '@components/SingleArticleInspirations/SingleArticleInspirations';
const FourProjects = () => {
  const {
    t
  } = useTranslation('common');
  const [projects, setProjects] = useState<ICmsArticles | null>(null);
  const getFourProjects = async () => {
    const fourProjects = await getArticles(4, 'interior-designs');
    setProjects(fourProjects);
  };
  useEffect(() => {
    if (!projects) {
      getFourProjects();
    }
  });
  if (!projects || !projects?.documents?.length) return null;
  return <div sx={styles.container}>
      <Heading h={2} size={40} uppercase mobile>
        {t('fourProjects.title')}
      </Heading>
      <div sx={styles.projectsContainer}>
        {projects?.documents && projects.documents.length > 0 && projects.documents.map(article => <Fragment key={`${article.id}-${Math.random()}`}>
              <SingleArticleInspirations article={article} key={`${article.id}-${Math.random()}`} isInterior buttonHistoryBack />
            </Fragment>)}
      </div>
    </div>;
};
export default FourProjects;